import React, { FunctionComponent } from "react";
import classNames from "classnames";
import "./floating-header.css";
import { Container } from "@mui/material";
import { profileListHref } from "../../constants/profile-links";

export interface FloatingHeaderProps {
  RightComponent: FunctionComponent;
  isMunicipalityHome?: boolean;
  municipioQuerySuffix?: string;
}

export const FloatingHeader = ({
  RightComponent,
  isMunicipalityHome = false,
  municipioQuerySuffix = "",
}: FloatingHeaderProps) => {
  const floatingHeaderClassName = classNames("xvia-catalog-floating-header", {
    "xvia-catalog-floating-header--municipality": isMunicipalityHome,
  });

  return (
    <div className={floatingHeaderClassName}>
      <Container className="xvia-catalog-floating-header__container">
        <div className="xvia-catalog-floating-header__image-wrapper">
          <a
            href={process.env.PORTAL_URL || "/"}
            aria-label="Ir para o portal do Governo do Estado do Piauí"
          >
            <img
              src={`${process.env.PUBLIC_URL}/images/svgs/logo_white_descaracterizada.svg`}
              className="xvia-catalog-floating-header__image"
              alt="Governo do Estado do Piauí"
            />
          </a>
        </div>
        <div className="xvia-catalog-floating-header__elements">
          <div className="xvia-catalog-header__links">
            <ul>
              <li>
                <a
                  href={profileListHref("cidadao", municipioQuerySuffix)}
                  aria-label="Serviços ao cidadão"
                >
                  Cidadão
                </a>
              </li>
              <li>
                <a
                  href={profileListHref("servidor", municipioQuerySuffix)}
                  aria-label="Serviços para servidor público"
                >
                  Servidor
                </a>
              </li>
              <li>
                <a
                  href={profileListHref("empresa", municipioQuerySuffix)}
                  aria-label="Serviços para empresas"
                >
                  Empresa
                </a>
              </li>
            </ul>
          </div>
          <RightComponent />
        </div>
      </Container>
    </div>
  );
};
